import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn, BeforeInsert, BeforeUpdate } from "typeorm";
import * as bcrypt from 'bcrypt';
import { EmployeeRolesEnum } from "@analytics-soa/shared-models";
import { UserToDivisionEntity } from "./user-to-division.entity";
@Entity('user')
export class UserEntity {
    @PrimaryGeneratedColumn('increment', { name: 'id' }) id: number;
    @Column({
        type: 'varchar',
        nullable: false,
        unique: true,
        name: 'username'
    })
    username: string;
    @Column({
        type: 'varchar',
        nullable: false
    })
    password?: string; @Column({
        type: 'varchar',
        nullable: false
    })
    @Column({
        type: 'enum',
        // length:5,
        nullable: true,
        enum: EmployeeRolesEnum,
        default: EmployeeRolesEnum.ADMIN,
        name: "role"
    })
    employeeRole: EmployeeRolesEnum;

    @Column({
        type: 'varchar',
        nullable: true
    })
    email: string;
    @Column({
        type: 'varchar',
        nullable: false,
        name: 'client_code'
    })
    clientCode: string;
    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;
    @BeforeInsert()
    // @BeforeUpdate()
    async hashPassword() {
        if (this.password) {

            this.password = await bcrypt.hash(this.password, 10);
        }
    }

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "created_user"
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user"
    })
    updatedUser: string | null;
    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;
    @OneToMany(() => UserToDivisionEntity,(userToDev)=> userToDev.userId)
    userToDivisionEntity : UserToDivisionEntity[];
    // @ManyToOne(type => UserEntity)owner?: UserEntity;
    // @OneToOne(() => EmployeeDetails, employeeDetails => employeeDetails.employeeId) 
    // // specify inverse side as a second parameter
    // employeeDetails: EmployeeDetails;

    // @ManyToOne(type => EmployeeDetails, employeeDetails => employeeDetails.employeeId, { nullable: false, })
    // @JoinColumn({ name: "employee_id" })
    // empInfo: EmployeeDetails;

}